/* hs-desktop.js */
(function () {
  'use strict';

  function initDesktopSlideshow() {
    var el = document.getElementById('HsDesktop');
    if (!el || typeof Splide === 'undefined') return;
    if (window.innerWidth <= 768) return;

    var splide = new Splide(el, {
      direction: 'ttb',
      height: 'calc(100dvh - var(--announcement-bar-height, 0px))',
      autoHeight: false, pagination: false, arrows: false,
      wheel: true, releaseWheel: true, wheelSleep: 900,
      wheelMinThreshold: 3, speed: 260, keyboard: true, type: 'slide'
    });

    var header = document.querySelector('x-header');

    function applyStyle(slideEl) {
      if (!header) return;
      var style = slideEl ? (slideEl.getAttribute('data-header') || 'solid') : 'solid';
      if (style === 'transparent') {
        header.classList.remove('is-scrolled', 'is-solid');
        header.classList.add('is-transparent');
      } else {
        header.classList.remove('is-scrolled', 'is-transparent');
        header.classList.add('is-solid');
      }
    }

    // Block theme scroll listener from interfering
    var _o = window.addEventListener.bind(window);
    window.addEventListener = function(t, fn, opts) {
      if (t === 'scroll') return;
      _o(t, fn, opts);
    };

    // Assert repeatedly to beat theme init
    var firstSlide = el.querySelector('[data-header]');
    var ticks = 0;
    var ticker = setInterval(function() {
      applyStyle(firstSlide);
      if (++ticks > 40) clearInterval(ticker);
    }, 50);

    splide.on('ready', function() {
      clearInterval(ticker);
      applyStyle(splide.Components.Elements.slides[0]);
    });
    splide.on('move', function(i) {
      applyStyle(splide.Components.Elements.slides[i]);
    });
    splide.mount();

    document.addEventListener('wheel', function(e) {
      if (document.getElementById('HsDesktop')) e.preventDefault();
    }, { passive: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDesktopSlideshow);
  } else {
    initDesktopSlideshow();
  }
})();
